<template>
  <div class="w-full">
    <!-- Trigger rebuild 210 adjustments -->
    <vs-popup
      :active.sync="localActive"
      class="modal-disparo-massa modal-reagendamento-massa"
      :class="{
        'modal-expanded': (etapa === 'preview' || etapa === 'progresso') && abaAtiva === 0,
        'modal-historico-largo': abaAtiva === 1 && etapa !== 'progresso'
      }"
      :title="tituloModal"
      button-close-hidden
    >
      <div
        id="disparo-massa-container"
        class="vs-con-loading__container w-full p-4 pt-0"
        @click.stop
      >
        <input
          style="
            position: absolute;
            opacity: 0;
            width: 0;
            height: 0;
            border: none;
            padding: 0;
            margin: 0;
            pointer-events: none;
          "
          autofocus
        />

        <!-- ESTADO DE PROGRESSO -->
        <div v-if="etapa === 'progresso'" class="py-4">
          <div class="text-center mb-6">
            <vs-icon
              v-if="progress.status === 'completed' && progress.failed > 0 && progress.sent === 0"
              icon="cancel"
              size="48px"
              color="#ea5455"
              class="animate-bounce-in"
            ></vs-icon>
            <vs-icon
              v-else-if="progress.status === 'completed' && progress.failed > 0 && progress.sent > 0"
              icon="warning"
              size="48px"
              color="#ff9f43"
              class="animate-bounce-in"
            ></vs-icon>
            <vs-icon
              v-else-if="progress.status === 'completed'"
              icon="check_circle"
              size="48px"
              color="#28c76f"
              class="animate-bounce-in"
            ></vs-icon>
            <vs-icon
              v-else-if="progress.status === 'error'"
              icon="error"
              size="48px"
              color="#ea5455"
            ></vs-icon>
            <div v-else class="spinner-pulse"></div>

            <h4 class="mt-3" :style="{ color: corStatus }">
              <template v-if="progress.status === 'completed'">
                <span v-if="progress.failed > 0 && progress.sent === 0">Envio finalizado com erro!</span>
                <span v-else-if="progress.failed > 0 && progress.sent > 0">Envio finalizado com falhas parciais!</span>
                <span v-else>Processamento finalizado com sucesso!</span>
              </template>
              <template v-else>
                {{ progress.message }}
              </template>
            </h4>
          </div>

          <div class="progress-container mb-6">
            <div class="progress-info">
              <span class="text-sm font-semibold"
                >Progresso do Reagendamento</span
              >
              <span class="text-sm font-bold" :style="{ color: corStatus }"
                >{{ progress.percent }}%</span
              >
            </div>
            <div class="progress-bar-bg">
              <div
                class="progress-bar-fill"
                :style="{
                  width: progress.percent + '%',
                  backgroundColor: corStatus,
                }"
              ></div>
            </div>
          </div>

          <div class="counters-grid">
            <div class="counter-card">
              <vs-icon icon="list_alt" size="24px" color="#00bba2"></vs-icon>
              <span class="counter-value">{{ progress.total }}</span>
              <span class="counter-label">Total</span>
            </div>
            <div class="counter-card counter-success">
              <vs-icon
                icon="check_circle"
                size="24px"
                color="#28c76f"
              ></vs-icon>
              <span class="counter-value text-success">{{
                progress.sent
              }}</span>
              <span class="counter-label">Enviados</span>
            </div>
            <div class="counter-card counter-danger">
              <vs-icon icon="cancel" size="24px" color="#ea5455"></vs-icon>
              <span class="counter-value text-danger">{{
                progress.failed
              }}</span>
              <span class="counter-label">Falhas</span>
            </div>
          </div>

          <div class="text-center mt-8">
            <vs-button
              v-if="
                progress.status === 'completed' || progress.status === 'error'
              "
              :color="progress.status === 'completed' ? (progress.failed > 0 ? (progress.sent === 0 ? 'danger' : 'warning') : 'success') : 'danger'"
              size="large"
              icon="done_all"
              @click="fecharComSucesso"
            >
              <template v-if="progress.status === 'completed'">
                <span v-if="progress.failed > 0 && progress.sent === 0">Fechar (Falha Geral)</span>
                <span v-else-if="progress.failed > 0 && progress.sent > 0">Concluído com Alerta</span>
                <span v-else>Concluído! Fechar</span>
              </template>
              <template v-else>
                Fechar
              </template>
            </vs-button>
            <vs-button v-else disabled color="dark" type="border" size="large">
              <span class="dot-pulse-inline"></span> Processando...
            </vs-button>
          </div>
        </div>

        <!-- ESTADO NORMAL: TABS DE NOVO ENVIO & HISTÓRICO -->
        <div v-else>
          <vs-tabs color="#00bba2" v-model="abaAtiva" v-if="localActive">
            
            <!-- TAB 1: NOVO REAGENDAMENTO -->
            <vs-tab label="Novo Reagendamento" icon="send">
              <!-- ETAPA DE SELECAO / UPLOAD -->
              <div v-if="etapa === 'selecao'" class="py-4">
          <div class="mb-5 text-center">
            <p class="text-sm text-grey-dark">
              Importe uma planilha Excel para agendar o reagendamento preventivo
              de OSs e enviar templates de notificação do WATI.
            </p>
            <!-- Links para templates de exemplo -->
            <div class="template-download-container">
              <div class="flex items-center justify-center gap-3 text-xs flex-wrap">
                <span
                  @click="isDownloading ? null : baixarTemplate('tela')"
                  class="template-download-link flex items-center gap-1"
                  :style="{ cursor: isDownloading ? 'not-allowed' : 'pointer', fontWeight: 600, opacity: isDownloading ? 0.6 : 1 }"
                  title="Baixa apenas as OSs que estão aparecendo na tela atualmente"
                >
                  <span v-if="isDownloading && tipoDownloading === 'tela'" class="spinner-inline mr-1" style="border-top-color: #00bba2;"></span>
                  <vs-icon v-else icon="filter_list" size="16px"></vs-icon>
                  Baixar OSs da Tela ({{ osList ? osList.length : 0 }})
                </span>
                <span style="color: #cbd5e0; margin: 0 5px;">|</span>
                <span
                  @click="isDownloading ? null : baixarTemplate('todas')"
                  class="template-download-link flex items-center gap-1"
                  :style="{ cursor: isDownloading ? 'not-allowed' : 'pointer', opacity: isDownloading ? 0.6 : 1 }"
                  title="Baixa todas as OSs ativas registradas no sistema"
                >
                  <span v-if="isDownloading && tipoDownloading === 'todas'" class="spinner-inline mr-1" style="border-top-color: #00bba2;"></span>
                  <vs-icon v-else icon="cloud_download" size="16px"></vs-icon>
                  Baixar Todas as OSs Ativas (Geral)
                </span>
                <span style="color: #cbd5e0; margin: 0 5px;">|</span>
                <a
                  href="/instrucoes_ia_reagendamento.md"
                  download="instrucoes_ia_reagendamento.md"
                  class="template-download-link flex items-center gap-1"
                  style="cursor: pointer; font-weight: 700; color: #7367f0;"
                >
                  <vs-icon icon="info" size="16px"></vs-icon>
                  Baixar Instruções para IA
                </a>
              </div>
            </div>
            
            <!-- Barra de Progresso do Download -->
            <div v-if="isDownloading" class="mt-4 mx-auto p-4 rounded text-center max-w-md" style="background: rgba(115, 103, 240, 0.05); border: 1px solid rgba(115, 103, 240, 0.2);">
              <div class="flex items-center justify-between text-xs font-semibold mb-2" style="color: #7367f0;">
                <span>Baixando planilha de OSs ({{ downloadedSizeText }})...</span>
                <span>{{ downloadProgress }}%</span>
              </div>
              <div style="background: #e2e8f0; border-radius: 9999px; height: 8px; overflow: hidden; width: 100%;">
                <div :style="{ width: downloadProgress + '%', background: '#7367f0', height: '100%', transition: 'width 0.15s ease-out' }"></div>
              </div>
            </div>
          </div>

          <!-- Dropzone Area -->
          <div
            class="dropzone-area p-8 text-center border-dashed rounded-lg cursor-pointer transition-all duration-300"
            @click="triggerFileInput"
            @dragover.prevent="dragOver = true"
            @dragleave.prevent="dragOver = false"
            @drop.prevent="onFileDrop"
            :class="{ 'dropzone-active': dragOver }"
          >
            <input
              type="file"
              ref="fileInput"
              class="hidden"
              @change="onFileChange"
              accept=".xlsx,.xls"
            />
            <vs-icon icon="cloud_upload" size="48px" color="#00bba2"></vs-icon>
            <p class="mt-2 text-sm font-semibold text-grey-dark">
              Arraste seu arquivo Excel aqui ou clique para selecionar
            </p>
            <span class="text-xs text-grey block mt-1"
              >Apenas arquivos .xlsx contendo a aba "MUDANÇAS DE HORARIO"</span
            >
          </div>

          <!-- Botão Digitar Manualmente -->
          <div class="text-center mt-6 p-4 rounded" style="background: rgba(0, 187, 162, 0.03); border: 1px dashed rgba(0, 187, 162, 0.15);">
            <span class="text-xs text-grey-dark block mb-2 font-semibold">Prefere fazer a alteração diretamente pelo sistema?</span>
            <vs-button 
              color="#00bba2" 
              type="filled" 
              icon="edit"
              @click="carregarOsAtivas"
            >
              Digitar Horários Manualmente na Tela
            </vs-button>
          </div>

          <div class="flex justify-end mt-6">
            <vs-button color="dark" type="border" @click="closeModal">
              Cancelar
            </vs-button>
          </div>
        </div>

        <!-- ETAPA DE PREVIEW -->
        <div v-else-if="etapa === 'preview'" class="pb-4">
          <!-- Resumo da Data Proposta e Importar Planilha -->
          <div class="flex items-center justify-between mb-4 gap-4">
            <div
              class="date-summary-banner p-3 rounded flex items-center justify-between flex-grow mr-2"
              style="
                background: rgba(0, 187, 162, 0.05);
                border: 1px solid rgba(0, 187, 162, 0.2);
              "
            >
              <div class="flex items-center" style="display: flex; align-items: center;">
                <i class="vs-icon notranslate material-icons mr-2" style="font-size: 18px; color: #00bba2; line-height: 1; display: inline-flex; align-items: center; justify-content: center;">calendar_today</i>
                <span class="text-sm font-semibold mr-3" style="line-height: 1.5; margin-left: 4px;">Data do Reagendamento:</span>
              </div>
              <input 
                type="date" 
                v-model="dataSelecionadaInput" 
                class="date-picker-input text-center"
                style="width: 150px;"
                @change="onDateChange"
              />
            </div>
            
            <vs-input
              icon-no-border
              icon="search"
              placeholder="Buscar por OS, cliente ou contato..."
              v-model="searchQuery"
              style="width: 320px;"
            />
          </div>

          <!-- Alerta de Contatos Nulos ou Erros -->
          <div 
            v-if="preview.filter(p => p.status !== 'valido').length > 0" 
            class="mb-4 p-3 rounded flex items-center justify-between"
            style="background: rgba(234, 84, 85, 0.05); border: 1px solid rgba(234, 84, 85, 0.2); display: flex;"
          >
            <div class="flex items-center gap-2" style="display: flex; align-items: center; gap: 8px;">
              <vs-icon icon="warning" color="danger" size="20px"></vs-icon>
              <span class="text-xs font-semibold" style="color: #ea5455;">
                Atenção: Identificamos <strong>{{ preview.filter(p => p.status !== 'valido').length }} OS(s) com pendências</strong> (como falta de contato de confirmação ou horário inválido). Estas OSs serão ignoradas no disparo.
              </span>
            </div>
            <vs-button 
              color="danger" 
              type="flat" 
              size="small" 
              style="padding: 4px 8px; font-size: 11px;"
              @click="toggleFiltro('invalidos')"
            >
              Verificar Pendentes
            </vs-button>
          </div>

          <!-- Filtros Rápidos -->
          <div class="flex flex-wrap items-center gap-2 mb-4 px-2 py-2 rounded bg-grey-lightest" style="border: 1px solid #edf2f7; gap: 8px; display: flex; align-items: center;">
            <span class="text-xs font-bold text-grey-dark uppercase tracking-wider mr-1" style="display: flex; align-items: center; gap: 4px;">
              <i class="vs-icon notranslate material-icons" style="font-size: 14px; color: #718096; vertical-align: middle;">filter_list</i>
              Filtrar por:
            </span>
            
            <!-- Todos -->
            <vs-button 
              v-if="filtrosAtivos.length === 0"
              key="todos_filled"
              type="filled" 
              color="#1b2a47" 
              size="small" 
              style="padding: 6px 12px; font-weight: 600;"
              @click="toggleFiltro('todos')"
            >
              Todos ({{ preview.length }})
            </vs-button>
            <vs-button 
              v-else
              key="todos_flat"
              type="flat" 
              color="#1b2a47" 
              size="small" 
              style="padding: 6px 12px; font-weight: 600;"
              @click="toggleFiltro('todos')"
            >
              Todos ({{ preview.length }})
            </vs-button>

            <!-- Válidos -->
            <vs-button 
              v-if="filtrosAtivos.includes('validos')"
              key="validos_filled"
              type="filled" 
              color="#28c76f" 
              size="small" 
              style="padding: 6px 12px; font-weight: 600;"
              @click="toggleFiltro('validos')"
            >
              Válidos ({{ preview.filter(p => p.status === 'valido').length }})
            </vs-button>
            <vs-button 
              v-else
              key="validos_flat"
              type="flat" 
              color="#28c76f" 
              size="small" 
              style="padding: 6px 12px; font-weight: 600;"
              @click="toggleFiltro('validos')"
            >
              Válidos ({{ preview.filter(p => p.status === 'valido').length }})
            </vs-button>

            <!-- Inválidos -->
            <vs-button 
              v-if="filtrosAtivos.includes('invalidos')"
              key="invalidos_filled"
              type="filled" 
              color="#ea5455" 
              size="small" 
              style="padding: 6px 12px; font-weight: 600;"
              @click="toggleFiltro('invalidos')"
            >
              Com Pendência/Inválidos ({{ preview.filter(p => p.status !== 'valido').length }})
            </vs-button>
            <vs-button 
              v-else
              key="invalidos_flat"
              type="flat" 
              color="#ea5455" 
              size="small" 
              style="padding: 6px 12px; font-weight: 600;"
              @click="toggleFiltro('invalidos')"
            >
              Com Pendência/Inválidos ({{ preview.filter(p => p.status !== 'valido').length }})
            </vs-button>

            <!-- Com Contato -->
            <vs-button 
              v-if="filtrosAtivos.includes('com_contato')"
              key="com_contato_filled"
              type="filled" 
              color="#7367f0" 
              size="small" 
              style="padding: 6px 12px; font-weight: 600;"
              @click="toggleFiltro('com_contato')"
            >
              Com Contato ({{ preview.filter(p => p.contatoConfirmacao !== '-').length }})
            </vs-button>
            <vs-button 
              v-else
              key="com_contato_flat"
              type="flat" 
              color="#7367f0" 
              size="small" 
              style="padding: 6px 12px; font-weight: 600;"
              @click="toggleFiltro('com_contato')"
            >
              Com Contato ({{ preview.filter(p => p.contatoConfirmacao !== '-').length }})
            </vs-button>

            <!-- Sem Contato -->
            <vs-button 
              v-if="filtrosAtivos.includes('sem_contato')"
              key="sem_contato_filled"
              type="filled" 
              color="#ff9f43" 
              size="small" 
              style="padding: 6px 12px; font-weight: 600;"
              @click="toggleFiltro('sem_contato')"
            >
              Sem Contato ({{ preview.filter(p => p.contatoConfirmacao === '-').length }})
            </vs-button>
            <vs-button 
              v-else
              key="sem_contato_flat"
              type="flat" 
              color="#ff9f43" 
              size="small" 
              style="padding: 6px 12px; font-weight: 600;"
              @click="toggleFiltro('sem_contato')"
            >
              Sem Contato ({{ preview.filter(p => p.contatoConfirmacao === '-').length }})
            </vs-button>

            <!-- Sem Hora Atual -->
            <vs-button 
              v-if="filtrosAtivos.includes('sem_hora_atual')"
              key="sem_hora_atual_filled"
              type="filled" 
              color="#5b6e7f" 
              size="small" 
              style="padding: 6px 12px; font-weight: 600;"
              @click="toggleFiltro('sem_hora_atual')"
            >
              Sem Hora Atual ({{ preview.filter(p => p.horaAtual === '-' || !p.horaAtual).length }})
            </vs-button>
            <vs-button 
              v-else
              key="sem_hora_atual_flat"
              type="flat" 
              color="#5b6e7f" 
              size="small" 
              style="padding: 6px 12px; font-weight: 600;"
              @click="toggleFiltro('sem_hora_atual')"
            >
              Sem Hora Atual ({{ preview.filter(p => p.horaAtual === '-' || !p.horaAtual).length }})
            </vs-button>

            <!-- Hora não digitada -->
            <vs-button 
              v-if="filtrosAtivos.includes('pendente_hora')"
              key="pendente_hora_filled"
              type="filled" 
              color="#00bba2" 
              size="small" 
              style="padding: 6px 12px; font-weight: 600;"
              @click="toggleFiltro('pendente_hora')"
            >
              Hora não digitada ({{ preview.filter(p => !p.horaProposta).length }})
            </vs-button>
            <vs-button 
              v-else
              key="pendente_hora_flat"
              type="flat" 
              color="#00bba2" 
              size="small" 
              style="padding: 6px 12px; font-weight: 600;"
              @click="toggleFiltro('pendente_hora')"
            >
              Hora não digitada ({{ preview.filter(p => !p.horaProposta).length }})
            </vs-button>
          </div>

          <!-- Tabela de Preview de Itens da Planilha -->
          <div class="mb-4">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px; padding: 0 8px; flex-wrap: wrap; gap: 12px;">
              <!-- Grupo Esquerdo (Controles e Seleção) -->
              <div style="display: flex; align-items: center; gap: 20px; flex-wrap: wrap;">
                <label class="select-label m-0 font-bold text-sm" style="color: #2d3748;">
                  Itens para Reagendar ({{ osSelecionadas.length }} de {{ preview.filter(p => p.status === 'valido').length }} válidos)
                </label>
                
                <vs-checkbox
                  @input="toggleAll"
                  :value="
                    osSelecionadas.length ===
                    preview.filter((p) => p.status === 'valido').length
                  "
                  color="success"
                  class="text-xs font-semibold text-grey-dark"
                  :disabled="
                    preview.filter((p) => p.status === 'valido').length === 0
                  "
                  style="margin-top: 0;"
                >
                  Selecionar Todos Válidos
                </vs-checkbox>

                <div style="display: flex; align-items: center; gap: 6px;">
                  <span class="text-xs text-grey-dark font-semibold">Linhas por página:</span>
                  <select v-model="linhasPorPagina" class="date-picker-input py-1 text-center" style="width: 80px; font-size: 12px; font-weight: bold; cursor: pointer; height: auto;">
                    <option :value="10">10</option>
                    <option :value="25">25</option>
                    <option :value="50">50</option>
                    <option :value="100">100</option>
                    <option :value="1000">Todas</option>
                  </select>
                </div>
              </div>

              <!-- Grupo Direito (Importação) -->
              <div>
                <vs-button 
                  color="#00bba2" 
                  type="border" 
                  icon="cloud_upload"
                  size="small"
                  @click="etapa = 'selecao'"
                  style="white-space: nowrap;"
                >
                  Importar Planilha Excel
                </vs-button>
              </div>
            </div>

            <!-- Skeleton Loader da Tabela -->
            <div v-if="loadingTable" class="preview-table-container p-4" style="padding: 16px;">
              <div class="skeleton-table">
                <!-- Header Skeleton -->
                <div class="flex mb-4 border-b pb-2 gap-4" style="display: flex; border-bottom: 1px solid #edf2f7; padding-bottom: 8px; margin-bottom: 16px; gap: 16px;">
                  <div class="skeleton-block" style="width: 40px; height: 16px; background: #e2e8f0; border-radius: 4px;"></div>
                  <div class="skeleton-block" style="width: 60px; height: 16px; background: #e2e8f0; border-radius: 4px;"></div>
                  <div class="skeleton-block flex-grow" style="height: 16px; background: #e2e8f0; border-radius: 4px; flex-grow: 1;"></div>
                  <div class="skeleton-block" style="width: 100px; height: 16px; background: #e2e8f0; border-radius: 4px;"></div>
                  <div class="skeleton-block" style="width: 80px; height: 16px; background: #e2e8f0; border-radius: 4px;"></div>
                  <div class="skeleton-block" style="width: 80px; height: 16px; background: #e2e8f0; border-radius: 4px;"></div>
                  <div class="skeleton-block" style="width: 90px; height: 16px; background: #e2e8f0; border-radius: 4px;"></div>
                  <div class="skeleton-block" style="width: 160px; height: 16px; background: #e2e8f0; border-radius: 4px;"></div>
                  <div class="skeleton-block" style="width: 120px; height: 16px; background: #e2e8f0; border-radius: 4px;"></div>
                </div>
                <!-- Rows Skeletons (5 rows) -->
                <div v-for="i in 5" :key="i" class="flex py-3 border-b gap-4 animate-pulse" style="display: flex; padding-top: 12px; padding-bottom: 12px; border-bottom: 1px solid #edf2f7; gap: 16px; align-items: center;">
                  <div class="skeleton-block" style="width: 30px; height: 20px; background: #edf2f7; border-radius: 4px;"></div>
                  <div class="skeleton-block" style="width: 50px; height: 20px; background: #edf2f7; border-radius: 4px;"></div>
                  <div class="skeleton-block flex-grow" style="height: 20px; background: #edf2f7; border-radius: 4px; flex-grow: 1;"></div>
                  <div class="skeleton-block" style="width: 110px; height: 20px; background: #edf2f7; border-radius: 4px;"></div>
                  <div class="skeleton-block" style="width: 80px; height: 20px; background: #edf2f7; border-radius: 4px;"></div>
                  <div class="skeleton-block" style="width: 80px; height: 20px; background: #edf2f7; border-radius: 4px;"></div>
                  <div class="skeleton-block" style="width: 80px; height: 32px; background: #edf2f7; border-radius: 6px;"></div>
                  <div class="skeleton-block" style="width: 150px; height: 32px; background: #edf2f7; border-radius: 6px;"></div>
                  <div class="skeleton-block" style="width: 100px; height: 32px; background: #edf2f7; border-radius: 6px;"></div>
                </div>
              </div>
            </div>

            <div v-else class="preview-table-container">
              <vs-table
                :data="filteredPreview"
                stripe
                :max-items="linhasPorPagina"
                pagination
                :key="filtrosAtivos.join(',') + '_' + searchQuery + '_' + linhasPorPagina"
              >
                <template slot="thead">
                  <vs-th style="width: 44px; text-align: center; padding: 10px 6px;"></vs-th>
                  <vs-th style="width: 80px; padding: 10px 8px;">OS</vs-th>
                  <vs-th style="min-width: 160px; padding: 10px 8px;">Cliente</vs-th>
                  <vs-th style="min-width: 260px; padding: 10px 8px;">Contato</vs-th>
                  <vs-th style="width: 80px; text-align: center; padding: 10px 6px;">Data Antiga</vs-th>
                  <vs-th style="width: 80px; text-align: center; padding: 10px 6px;">Hora Antiga</vs-th>
                  <vs-th style="width: 130px; text-align: center; padding: 10px 6px;">Data Nova</vs-th>
                  <vs-th style="width: 90px; text-align: center; padding: 10px 6px;">Hora Nova</vs-th>
                  <vs-th style="min-width: 140px; padding: 10px 8px;">Motivo</vs-th>
                  <vs-th style="width: 90px; text-align: center; padding: 10px 6px;">Status</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data" :class="{ 'tr-invalido': tr.status !== 'valido' }">
                    <!-- Checkbox -->
                    <vs-td style="width: 44px; text-align: center; padding: 8px 6px;">
                      <vs-checkbox
                        v-model="osSelecionadas"
                        :vs-value="tr.osId"
                        color="success"
                        :disabled="tr.status !== 'valido'"
                      ></vs-checkbox>
                    </vs-td>

                    <!-- OS ID -->
                    <vs-td style="width: 80px; padding: 8px;">
                      <span class="os-id-badge">#{{ tr.osId }}</span>
                    </vs-td>

                    <!-- Cliente -->
                    <vs-td style="min-width: 160px; padding: 8px;" class="text-xs">
                      <span :title="tr.cliente" style="font-weight: 600; color: #2d3748; line-height: 1.3; display: block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 220px;">{{ tr.cliente }}</span>
                    </vs-td>

                    <!-- Contato -->
                    <vs-td style="width: 280px; padding: 8px; white-space: nowrap;">
                      <div style="display: flex; align-items: flex-start; gap: 6px;">
                        <div style="flex: 1; min-width: 0;">
                          <el-select 
                            v-if="contatosValidos(tr).length > 0"
                            v-model="tr.contatoId" 
                            @change="selecionarContatoRow(tr)"
                            placeholder="Selecione..."
                            size="mini"
                            style="width: 100%; max-width: 235px;"
                            clearable
                            filterable
                            popper-class="select-contato-popper"
                          >
                            <el-option
                              v-for="c in contatosValidos(tr)"
                              :key="c.id"
                              :label="c.nome"
                              :value="c.id"
                            >
                              <span style="float: left; font-size: 11px; font-weight: 600; color: #2d3748;">{{ c.nome }}</span>
                              <span style="float: right; color: #718096; font-size: 10px; margin-left: 12px;">{{ formatarTelefone(c.contato) }}</span>
                            </el-option>
                          </el-select>
                          <div v-else>
                            <span style="color: #e53e3e; font-size: 11px; font-weight: 700; letter-spacing: 0.2px; white-space: nowrap;">
                              Sem Contato
                            </span>
                          </div>

                          <!-- Número do contato selecionado -->
                          <div v-if="tr.contatoConfirmacao && tr.contatoConfirmacao !== '-'" style="font-size: 10px; color: #4a5568; font-weight: 600; margin-top: 3px; white-space: nowrap;">
                            {{ formatarTelefone(tr.contatoConfirmacao) }}
                          </div>
                        </div>

                        <!-- Botão para abrir o modal de contatos oficial do sistema -->
                        <button 
                          @click="abrirModalContatosParaLinha(tr)"
                          style="background: #e1f5fe; border: 1px solid #b3e5fc; border-radius: 4px; padding: 4px; cursor: pointer; color: #0288d1; display: flex; align-items: center; justify-content: center; width: 24px; height: 24px; transition: all 0.2s; flex-shrink: 0; margin-top: 3px;"
                          title="Adicionar ou Editar contatos deste cliente"
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
                        </button>
                      </div>
                    </vs-td>

                    <!-- Data Atual -->
                    <vs-td style="width: 80px; text-align: center; padding: 8px 6px;">
                      <span class="table-date-text">{{ formatarDataBR(tr.dataAtual) }}</span>
                    </vs-td>

                    <!-- Hora Atual -->
                    <vs-td style="width: 80px; text-align: center; padding: 8px 6px;">
                      <span class="table-time-pill" v-if="tr.horaAtual && tr.horaAtual !== '-'">{{ tr.horaAtual }}</span>
                      <span v-else class="table-time-empty">—</span>
                    </vs-td>

                    <!-- Data Nova (editável) -->
                    <vs-td style="width: 130px; text-align: center; padding: 8px 6px;">
                      <input 
                        type="date" 
                        v-model="tr.dataPropostaRaw" 
                        class="table-cell-input text-center"
                        style="width: 120px; font-weight: 700; font-size: 11px; padding: 4px;"
                        @change="onRowDateChange(tr)"
                      />
                    </vs-td>

                    <!-- Hora Nova (editável) -->
                    <vs-td style="width: 90px; text-align: center; padding: 8px 6px;">
                      <input 
                        type="text" 
                        v-model="tr.horaProposta" 
                        placeholder="HH:MM" 
                        class="table-cell-input text-center"
                        style="width: 72px; font-weight: 700; font-size: 12px;"
                        maxlength="5"
                        @input="aplicarMascaraHora($event, tr)"
                        @blur="formatarHoraInline(tr)"
                      />
                    </vs-td>

                    <!-- Motivo -->
                    <vs-td style="min-width: 140px; padding: 8px;">
                      <input 
                        type="text" 
                        v-model="tr.motivoPlanilha" 
                        placeholder="Motivo (opcional)" 
                        class="table-cell-input w-full"
                        style="font-size: 11px;"
                      />
                    </vs-td>

                    <!-- Status Badge -->
                    <vs-td style="width: 90px; text-align: center; padding: 8px 6px;">
                      <el-tooltip 
                        v-if="tr.status !== 'valido'" 
                        :content="gerarTooltipPendencias(tr)" 
                        placement="top"
                        :open-delay="200"
                      >
                        <span class="status-badge status-badge--danger" :title="gerarTooltipPendencias(tr)" style="cursor: help;">
                          <i class="vs-icon notranslate material-icons" style="font-size: 13px;">error_outline</i>
                          Pendente
                        </span>
                      </el-tooltip>
                      <span v-else class="status-badge status-badge--success">
                        <i class="vs-icon notranslate material-icons" style="font-size: 13px;">check_circle</i>
                        Válido
                      </span>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>

          <!-- Template Select -->
          <div class="mb-6">
            <label class="select-label" style="display: flex; align-items: center; gap: 6px; margin-bottom: 8px;">
              <i class="vs-icon notranslate material-icons" style="font-size: 16px; color: #00bba2;">chat</i>
              Template de Notificação WATI
            </label>
            <div v-if="loadingTemplates" class="animate-pulse" style="height: 40px; background: #edf2f7; border: 1px solid #e2e8f0; border-radius: 6px; width: 100%;"></div>
            <el-select
              v-else
              v-model="templateSelecionadoId"
              class="w-full"
              size="medium"
              placeholder="Selecione o template de reagendamento..."
              popper-class="popper-select-template"
            >
              <el-option
                v-for="tpl in watiTemplates"
                :key="tpl.id"
                :value="tpl.id"
                :label="tpl.elementName"
              ></el-option>
            </el-select>
          </div>

          <!-- Ações -->
          <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; margin-top: 24px;">
            <vs-button
              color="dark"
              type="flat"
              icon="arrow_back"
              @click="voltarParaSelecao"
            >
              Importar Outro Arquivo
            </vs-button>
            <div style="display: flex; align-items: center; gap: 12px;">
              <vs-button color="dark" type="border" @click="closeModal">
                Cancelar
              </vs-button>
              <vs-button
                color="#00bba2"
                icon="send"
                @click="confirmarEnvio"
                :disabled="
                  osSelecionadas.length === 0 || !templateSelecionadoId
                "
              >
                Disparar Reagendamento ({{ osSelecionadas.length }} OSs)
              </vs-button>
            </div>
          </div>
        </div>
      </vs-tab>

        <!-- TAB 2: HISTÓRICO DE REAGENDAMENTOS -->
        <vs-tab label="Histórico de Reagendamentos" icon="history">
          <div class="py-4">
            <!-- Filtros de Histórico -->
            <div style="display: flex; flex-wrap: wrap; align-items: center; gap: 16px; margin-bottom: 16px; background: #f7fafc; padding: 12px; border-radius: 8px; border: 1px solid #e2e8f0; width: 100%;">
              <div style="display: flex; flex-direction: column; gap: 4px;">
                <label style="font-size: 11px; font-weight: 700; color: #4a5568;">Período:</label>
                <select 
                  v-model="filtroHistoricoDias" 
                  @change="aoMudarFiltroDias"
                  style="font-size: 12px; padding: 6px; border: 1px solid #cbd5e0; border-radius: 4px; background: #fff; width: 150px; font-weight: 600; color: #2d3748;"
                >
                  <option :value="30">Últimos 30 dias</option>
                  <option :value="7">Últimos 7 dias</option>
                  <option :value="60">Últimos 60 dias</option>
                  <option :value="90">Últimos 90 dias</option>
                  <option value="custom">Período Personalizado</option>
                </select>
              </div>

              <div v-if="filtroHistoricoDias === 'custom'" style="display: flex; align-items: center; gap: 12px;">
                <div style="display: flex; flex-direction: column; gap: 4px;">
                  <label style="font-size: 11px; font-weight: 700; color: #4a5568;">De:</label>
                  <input 
                    type="date" 
                    v-model="filtroHistoricoDataInicio" 
                    style="font-size: 12px; padding: 5px; border: 1px solid #cbd5e0; border-radius: 4px; background: #fff; color: #2d3748;"
                  />
                </div>
                <div style="display: flex; flex-direction: column; gap: 4px;">
                  <label style="font-size: 11px; font-weight: 700; color: #4a5568;">Até:</label>
                  <input 
                    type="date" 
                    v-model="filtroHistoricoDataFim" 
                    style="font-size: 12px; padding: 5px; border: 1px solid #cbd5e0; border-radius: 4px; background: #fff; color: #2d3748;"
                  />
                </div>
              </div>

              <div style="display: flex; align-items: flex-end; margin-top: 16px;">
                <vs-button 
                  color="primary" 
                  size="small" 
                  icon="search" 
                  @click="fetchHistorico(true)"
                  style="height: 32px;"
                >
                  Filtrar
                </vs-button>
              </div>
            </div>

            <vs-table 
              :data="tabelaDados" 
              max-items="5" 
              pagination 
              search 
              noDataText="Nenhum reagendamento em lote encontrado."
              :class="{ 'table-loading': loadingHistorico }"
            >
              <template slot="thead">
                <vs-th sort-key="createdAt">Data</vs-th>
                <vs-th sort-key="templateName">Template</vs-th>
                <vs-th sort-key="status">Status</vs-th>
                <vs-th sort-key="enviados">Enviados</vs-th>
                <vs-th sort-key="confirmados">Confirmados</vs-th>
                <vs-th>Ações</vs-th>
              </template>
              <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].createdAt">
                    <div v-if="data[indextr].isSkeleton" class="skeleton-cell animate-shimmer" style="width: 120px; height: 16px; border-radius: 4px;"></div>
                    <template v-else>{{ formatData(data[indextr].createdAt) }}</template>
                  </vs-td>
                  <vs-td :data="data[indextr].templateName">
                    <div v-if="data[indextr].isSkeleton" class="skeleton-cell animate-shimmer" style="width: 160px; height: 16px; border-radius: 4px;"></div>
                    <template v-else>{{ data[indextr].templateName }}</template>
                  </vs-td>
                  <vs-td :data="data[indextr].status">
                    <div v-if="data[indextr].isSkeleton" class="skeleton-cell animate-shimmer" style="width: 80px; height: 16px; border-radius: 4px;"></div>
                    <vs-chip v-else :color="getStatusColor(data[indextr].status)">
                      {{ data[indextr].status.toUpperCase() }}
                    </vs-chip>
                  </vs-td>
                  <vs-td :data="data[indextr].enviados">
                    <div v-if="data[indextr].isSkeleton" class="skeleton-cell animate-shimmer" style="width: 50px; height: 16px; border-radius: 4px;"></div>
                    <template v-else>
                      <strong>{{ data[indextr].enviados }}</strong> / {{ data[indextr].totalOs }}
                    </template>
                  </vs-td>
                  <vs-td :data="data[indextr].confirmados">
                    <div v-if="data[indextr].isSkeleton" class="skeleton-cell animate-shimmer" style="width: 60px; height: 16px; border-radius: 4px;"></div>
                    <template v-else>
                      <span class="text-success font-bold">
                        {{ data[indextr].confirmados || 0 }}
                      </span>
                      <span class="text-grey text-xs">
                        ({{ data[indextr].enviados > 0 ? Math.round(((data[indextr].confirmados || 0) / data[indextr].enviados) * 100) : 0 }}%)
                      </span>
                    </template>
                  </vs-td>
                  <vs-td>
                    <div v-if="data[indextr].isSkeleton" class="skeleton-cell animate-shimmer" style="width: 40px; height: 16px; border-radius: 4px;"></div>
                    <template v-else>
                      <vs-button 
                        v-if="data[indextr].status === 'processing'" 
                        color="primary" 
                        type="border" 
                        size="small" 
                        icon="visibility" 
                        @click="retomarProgresso(data[indextr])"
                      >
                        Ver Progresso
                      </vs-button>
                      <span v-else class="text-xs text-grey font-semibold">Finalizado</span>
                    </template>
                  </vs-td>
                </vs-tr>
              </template>
              <template slot="expand" slot-scope="{data}">
                <div class="px-4 py-3 bg-white" style="border: 1px solid #f8f8f8; border-radius: 8px;">
                  <div class="flex items-center mb-2">
                    <vs-icon icon="info" size="18px" class="mr-2 text-primary"></vs-icon>
                    <h5 class="m-0 text-primary">Detalhes do Reagendamento #{{ data.id }}</h5>
                  </div>
                  <div class="flex mt-3">
                    <div class="w-1/2 pr-2" v-if="data.idsOsSucesso && data.idsOsSucesso.length > 0">
                       <p class="text-sm font-bold text-success mb-1">
                         <vs-icon icon="check_circle" size="14px"></vs-icon> OSs Processadas:
                       </p>
                       <div class="flex flex-wrap">
                         <vs-chip color="success" transparent v-for="id in data.idsOsSucesso" :key="'suc_'+id">OS #{{ id }}</vs-chip>
                       </div>
                    </div>
                    <div class="w-1/2 pl-2" v-if="data.idsOsFalha && data.idsOsFalha.length > 0">
                       <p class="text-sm font-bold text-danger mb-1">
                         <vs-icon icon="error_outline" size="14px"></vs-icon> OSs com Falha:
                       </p>
                       <div class="flex flex-wrap">
                         <vs-chip color="danger" transparent v-for="id in data.idsOsFalha" :key="'err_'+id">OS #{{ id }}</vs-chip>
                       </div>
                    </div>
                    <div class="w-full text-center py-4" v-if="(!data.idsOsSucesso || data.idsOsSucesso.length === 0) && (!data.idsOsFalha || data.idsOsFalha.length === 0)">
                      <p class="text-grey text-sm">Nenhum detalhe registrado para este lote.</p>
                    </div>
                  </div>
                </div>
              </template>
            </vs-table>
          </div>
        </vs-tab>
      </vs-tabs>
    </div>
      </div>
      
      <contactar-modal
        ref="modalContactarRef"
        :item="itemContactar"
        :tipo="'os_confirmacao'"
        @confirmacao-atualizada="onContatoAtualizadoRow"
        style="display: none;"
      />
    </vs-popup>
  </div>
</template>

<script>
import contactarModal from "./contactarModal.vue";

// ponytail: Uses the standard browser EventSource (SSE) natively for progress tracking, avoiding heavy web socket dependencies.
export default {
  name: "ModalReagendamentoMassa",
  components: {
    contactarModal
  },
  props: {
    active: { type: Boolean, default: false },
    osList: { type: Array, default: () => [] },
  },
  data() {
    return {
      localActive: false,
      etapa: "selecao", // 'selecao' | 'preview' | 'progresso'
      dragOver: false,
      selectedFile: null,
      preview: [],
      osSelecionadas: [],
      dataProposta: "",
      dataPropostaRaw: "",
      dataSelecionadaInput: "",
      searchQuery: "",
      filtrosAtivos: [], // Array of active filters
      abaAtiva: 0,
      historico: [],
      loadingHistorico: false,
      filtroHistoricoDias: 30,
      filtroHistoricoDataInicio: "",
      filtroHistoricoDataFim: "",
      itemContactar: { id: null, nomeCliente: "", id_cliente: null, id_contrato: null, id_contato_confirmacao: null },
      linhasPorPagina: 25,
      loadingTable: false,
      watiTemplates: [],
      templateSelecionadoId: null,
      loadingTemplates: false,
      progress: {
        total: 0,
        sent: 0,
        failed: 0,
        message: "Aguardando...",
        percent: 0,
        status: "",
      },
      isDownloading: false,
      downloadProgress: 0,
      downloadedSizeText: "",
      tipoDownloading: "",
      eventSource: null,
    };
  },
  computed: {
    filteredPreview() {
      let list = this.preview;
      
      // 1. Apply active filters cumulatively
      this.filtrosAtivos.forEach(filtro => {
        if (filtro === "validos") {
          list = list.filter(item => item.status === "valido");
        } else if (filtro === "invalidos") {
          list = list.filter(item => item.status !== "valido");
        } else if (filtro === "com_contato") {
          list = list.filter(item => item.contatoConfirmacao !== "-");
        } else if (filtro === "sem_contato") {
          list = list.filter(item => item.contatoConfirmacao === "-");
        } else if (filtro === "sem_hora_atual") {
          list = list.filter(item => item.horaAtual === "-" || !item.horaAtual);
        } else if (filtro === "pendente_hora") {
          list = list.filter(item => !item.horaProposta);
        }
      });

      // 2. Apply search filter
      if (!this.searchQuery) return list;
      const q = this.searchQuery.toLowerCase().trim();
      return list.filter((item) => {
        const id = String(item.osId || "");
        const cli = String(item.cliente || "").toLowerCase();
        const tel = String(item.contatoConfirmacao || "");
        return id.includes(q) || cli.includes(q) || tel.includes(q);
      });
    },
    tituloModal() {
      if (this.etapa === "progresso") return "Enviando Reagendamentos...";
      if (this.etapa === "preview") return "Visualização de Importação";
      return "Reagendamento em Massa";
    },
    corStatus() {
      if (this.progress.status === "completed") {
        if (this.progress.failed > 0) {
          if (this.progress.sent === 0) return "#ea5455";
          return "#ff9f43";
        }
        return "#28c76f";
      }
      if (this.progress.status === "error") return "#ea5455";
      return "#00bba2";
    },
    templateSelecionadoNome() {
      const tpl = this.watiTemplates.find(
        (t) => t.id === this.templateSelecionadoId,
      );
      return tpl ? tpl.elementName : "—";
    },
    tabelaDados() {
      if (this.loadingHistorico && this.historico.length === 0) {
        return Array.from({ length: 4 }).map((_, index) => ({
          id: `skeleton-${index}`,
          createdAt: "",
          templateName: "",
          status: "",
          enviados: 0,
          totalOs: 0,
          confirmados: 0,
          isSkeleton: true,
        }));
      }
      return this.historico;
    },
  },
  watch: {
    abaAtiva(val) {
      if (this.localActive) {
        const tabName = val === 1 ? "historico" : "novo";
        this.syncUrlQuery(tabName);

        if (val === 1) {
          this.fetchHistorico();
        } else {
          this.getWatiTemplates();
        }
      }
    },
    active(val) {
      this.localActive = val;
      if (val) {
        this.etapa = "selecao";
        this.selectedFile = null;
        this.preview = [];
        this.osSelecionadas = [];
        this.dataProposta = "";
        this.dataPropostaRaw = "";
        this.dataSelecionadaInput = "";
        this.searchQuery = "";
        this.filtrosAtivos = [];
        this.linhasPorPagina = 25;
        this.loadingTable = false;
        this.templateSelecionadoId = null;
        this.historico = [];

        const queryTab = this.$route.query.disparo_aba || new URLSearchParams(window.location.search).get("disparo_aba");
        const targetTab = queryTab === "historico" ? 1 : 0;

        if (this.abaAtiva === targetTab) {
          if (targetTab === 1) {
            this.fetchHistorico();
          } else {
            this.getWatiTemplates();
          }
        }

        this.$nextTick(() => {
          this.abaAtiva = targetTab;
        });
      }
    },
    localActive(val) {
      if (!val) {
        this.closeEventSource();
        this.syncUrlQuery(null);
        this.$emit("update:active", false);
      }
    },
  },
  beforeDestroy() {
    this.closeEventSource();
    this.syncUrlQuery(null);
  },
  methods: {
    syncUrlQuery(tabName) {
      try {
        const url = new URL(window.location);
        if (tabName) {
          url.searchParams.set("disparo_aba", tabName);
          window.history.replaceState({}, "", url);
        } else {
          url.searchParams.delete("disparo_aba");
          window.history.replaceState({}, "", url);
        }
      } catch (e) {
        // ignore
      }
    },
    async fetchHistorico(force = false) {
      let queryParams = "";
      if (this.filtroHistoricoDias === 'custom') {
        if (this.filtroHistoricoDataInicio) {
          queryParams += (queryParams ? "&" : "?") + `data_inicio=${this.filtroHistoricoDataInicio}`;
        }
        if (this.filtroHistoricoDataFim) {
          queryParams += (queryParams ? "&" : "?") + `data_fim=${this.filtroHistoricoDataFim}`;
        }
      } else {
        queryParams += (queryParams ? "&" : "?") + `dias=${this.filtroHistoricoDias}`;
      }

      if (this.historico && this.historico.length > 0 && !force) {
        try {
          const res = await this.$http.get(`whatsapp/enviar-massa/historico/reagendamento${queryParams}`);
          const responseData = res.data || res;
          this.historico = Array.isArray(responseData) ? responseData : (responseData.data || []);
        } catch (err) {
          console.error("[ModalReagendamentoMassa] Erro ao buscar histórico em background:", err);
        }
        return;
      }
      this.loadingHistorico = true;
      try {
        const res = await this.$http.get(`whatsapp/enviar-massa/historico/reagendamento${queryParams}`);
        const responseData = res.data || res;
        this.historico = Array.isArray(responseData) ? responseData : (responseData.data || []);
      } catch (err) {
        console.error("[ModalReagendamentoMassa] Erro ao buscar histórico:", err);
      } finally {
        this.loadingHistorico = false;
      }
    },
    aoMudarFiltroDias() {
      if (this.filtroHistoricoDias !== 'custom') {
        this.fetchHistorico(true);
      }
    },
    formatData(iso) {
      if (!iso) return "";
      return new Date(iso).toLocaleString("pt-BR");
    },
    getStatusColor(status) {
      if (status === "completed") {
        return "success";
      }
      if (status === "error") return "danger";
      return "warning";
    },
    retomarProgresso(job) {
      if (job.status !== "processing") return;
      this.etapa = "progresso";
      this.progress = {
        total: job.totalOs,
        sent: job.enviados,
        failed: job.falhas,
        message: "Reconectando ao reagendamento...",
        percent: Math.round(((job.enviados + job.falhas) / job.totalOs) * 100) || 0,
        status: job.status,
      };
      this.iniciarProgressoSSE(job.id);
    },
    async carregarOsAtivas() {
      this.loadingTable = true;
      this.etapa = "preview";

      // Set tomorrow's date by default
      const amanha = new Date();
      amanha.setDate(amanha.getDate() + 1);
      const yyyy = amanha.getFullYear();
      const mm = String(amanha.getMonth() + 1).padStart(2, '0');
      const dd = String(amanha.getDate()).padStart(2, '0');
      this.dataSelecionadaInput = `${yyyy}-${mm}-${dd}`;
      this.dataProposta = `${dd}/${mm}/${yyyy}`;
      this.dataPropostaRaw = this.dataSelecionadaInput;

      // Populate preview using parent osList prop
      this.preview = this.osList.map(os => {
        const dataAtual = os.remarcado > 0 ? os.data_remarcacao : os.data_competencia;
        
        let dataFormatada = '-';
        if (dataAtual) {
          try {
            const d = new Date(dataAtual);
            if (!isNaN(d.getTime())) {
              dataFormatada = `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;
            } else {
              dataFormatada = String(dataAtual);
            }
          } catch {
            dataFormatada = String(dataAtual);
          }
        }

        return {
          osId: os.id,
          cliente: os.nomeCliente || 'Sem Nome',
          contatoConfirmacao: os.contatoConfirmacao || '-',
          nomeContatoConfirmacao: os.nomeContatoConfirmacao || '',
          contatosDisponiveis: [],
          contatoId: null,
          clienteId: null,
          contratoId: null,
          dataAtual: dataFormatada,
          horaAtual: os.hora_marcada || '-',
          dataProposta: this.dataProposta,
          dataPropostaRaw: this.dataPropostaRaw,
          horaProposta: "",
          motivoPlanilha: "",
          status: "invalido",
          motivoInvalido: "Novo horário inválido ou vazio"
        }
      });
      
      this.osSelecionadas = [];

      // Fetch contacts from backend in batch
      try {
        const osIds = this.preview.map(p => p.osId);
        if (osIds.length > 0) {
          const res = await this.$http.post('os/reagendar-massa/contatos-batch', { osIds });
          const contatosData = res.data || res;

          this.preview.forEach(row => {
            const info = contatosData[row.osId];
            if (info) {
              row.contatoConfirmacao = info.contatoConfirmacao || row.contatoConfirmacao;
              row.nomeContatoConfirmacao = info.nomeContatoConfirmacao || '';
              row.contatoId = info.contatoId || null;
              row.contatosDisponiveis = info.contatosDisponiveis || [];
              row.clienteId = info.clienteId || null;
              row.contratoId = info.contratoId || null;

              // Revalidate: if now has contact and status was only missing contact
              if (row.contatoConfirmacao && row.contatoConfirmacao !== '-') {
                if (row.motivoInvalido === 'Sem contato de confirmação') {
                  if (row.horaProposta && row.horaProposta !== '' && row.horaProposta !== '-') {
                    row.status = 'valido';
                    row.motivoInvalido = '';
                  }
                }
              }
            }
          });

          // Sort: rows with contact first
          this.preview.sort((a, b) => {
            const aHas = a.contatoConfirmacao && a.contatoConfirmacao !== '-';
            const bHas = b.contatoConfirmacao && b.contatoConfirmacao !== '-';
            if (aHas && !bHas) return -1;
            if (!aHas && bHas) return 1;
            return 0;
          });
        }
      } catch (err) {
        console.error('[carregarOsAtivas] Erro ao buscar contatos em batch:', err);
      }

      this.loadingTable = false;
    },
    toggleFiltro(tipo) {
      if (tipo === 'todos') {
        this.filtrosAtivos = [];
        return;
      }
      
      let ativos = [...this.filtrosAtivos];
      const index = ativos.indexOf(tipo);
      if (index > -1) {
        // Desmarcar filtro existente
        ativos.splice(index, 1);
      } else {
        // Marcar novo filtro
        // Tratar filtros contraditórios (exclusão mútua)
        if (tipo === 'validos') {
          ativos = ativos.filter(f => f !== 'invalidos');
        } else if (tipo === 'invalidos') {
          ativos = ativos.filter(f => f !== 'validos');
        } else if (tipo === 'com_contato') {
          ativos = ativos.filter(f => f !== 'sem_contato');
        } else if (tipo === 'sem_contato') {
          ativos = ativos.filter(f => f !== 'com_contato');
        }
        
        ativos.push(tipo);
      }
      this.filtrosAtivos = ativos;
    },
    aplicarMascaraHora(e, tr) {
      let val = e.target.value.replace(/\D/g, ''); // Keep only numbers
      if (val.length > 4) val = val.substring(0, 4);
      
      if (val.length > 2) {
        tr.horaProposta = `${val.substring(0, 2)}:${val.substring(2)}`;
      } else {
        tr.horaProposta = val;
      }
    },
    onDateChange() {
      if (!this.dataSelecionadaInput) return;
      const [year, month, day] = this.dataSelecionadaInput.split('-');
      const displayDate = `${day}/${month}/${year}`;
      this.dataProposta = displayDate;
      this.dataPropostaRaw = this.dataSelecionadaInput;
      this.preview.forEach(item => {
        item.dataProposta = displayDate;
        item.dataPropostaRaw = this.dataSelecionadaInput;
      });
    },
    onRowDateChange(tr) {
      if (tr.dataPropostaRaw) {
        const parts = tr.dataPropostaRaw.split('-');
        if (parts.length === 3) {
          tr.dataProposta = `${parts[2]}/${parts[1]}/${parts[0]}`;
        }
      }
    },
    formatarHoraInline(tr) {
      let val = String(tr.horaProposta || '').trim();
      if (!val) {
        tr.status = 'invalido';
        tr.motivoInvalido = 'Novo horário inválido ou vazio';
        this.osSelecionadas = this.osSelecionadas.filter(id => id !== tr.osId);
        return;
      }

      const cleanUpper = val.normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toUpperCase();
      if (cleanUpper === 'MANHA' || cleanUpper === 'M') {
        tr.horaProposta = 'Manhã';
        tr.status = 'valido';
        tr.motivoInvalido = '';
        if (!this.osSelecionadas.includes(tr.osId)) {
          this.osSelecionadas.push(tr.osId);
        }
        return;
      }
      if (cleanUpper === 'TARDE' || cleanUpper === 'T' || cleanUpper === 'LIVRE' || cleanUpper === 'L') {
        tr.horaProposta = 'Tarde';
        tr.status = 'valido';
        tr.motivoInvalido = '';
        if (!this.osSelecionadas.includes(tr.osId)) {
          this.osSelecionadas.push(tr.osId);
        }
        return;
      }
      if (cleanUpper === 'NOITE' || cleanUpper === 'N') {
        tr.horaProposta = 'Noite';
        tr.status = 'valido';
        tr.motivoInvalido = '';
        if (!this.osSelecionadas.includes(tr.osId)) {
          this.osSelecionadas.push(tr.osId);
        }
        return;
      }
      
      if (/^\d{1,2}$/.test(val)) {
        val = val.padStart(2, '0') + ':00';
      } else if (/^\d{3,4}$/.test(val)) {
        if (val.length === 3) val = '0' + val;
        val = `${val.substring(0,2)}:${val.substring(2,4)}`;
      }
      
      if (/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(val)) {
        const parts = val.split(':');
        tr.horaProposta = `${parts[0].padStart(2, '0')}:${parts[1]}`;
        tr.status = 'valido';
        tr.motivoInvalido = '';
        
        if (!this.osSelecionadas.includes(tr.osId)) {
          this.osSelecionadas.push(tr.osId);
        }
      } else {
        tr.status = 'invalido';
        tr.motivoInvalido = 'Novo horário inválido ou vazio';
        this.osSelecionadas = this.osSelecionadas.filter(id => id !== tr.osId);
        this.$vs.notify({ title: 'Aviso', text: 'Formato de hora inválido. Use HH:MM (ex: 14:30) ou turnos (ex: Manhã, Tarde, Noite).', color: 'warning' });
      }
    },
    formatarDataBR(val) {
      if (!val || val === '-' || val === '') return '-'
      // Se já veio dd/mm/yyyy
      if (/^\d{2}\/\d{2}\/\d{4}$/.test(val)) return val
      // Se veio yyyy-mm-dd (ISO do backend)
      if (/^\d{4}-\d{2}-\d{2}$/.test(val)) {
        const [y, m, d] = val.split('-')
        return `${d}/${m}/${y}`
      }
      // Fallback: tenta converter via Date
      try {
        const d = new Date(val)
        if (!isNaN(d.getTime())) {
          return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`
        }
      } catch (_) {}
      return String(val)
    },
    gerarTooltipPendencias(tr) {
      const itens = []
      if (!tr.contatoConfirmacao || tr.contatoConfirmacao === '-') {
        itens.push('☐ Sem contato de confirmação')
      }
      if (!tr.horaAtual || tr.horaAtual === '-') {
        itens.push('☐ Sem hora atual registrada')
      }
      if (!tr.horaProposta || tr.horaProposta === '') {
        itens.push('☐ Novo horário não preenchido')
      }
      if (tr.motivoInvalido && !itens.some(i => i.includes(tr.motivoInvalido))) {
        itens.push(`☐ ${tr.motivoInvalido}`)
      }
      return itens.length > 0 ? itens.join('\n') : 'Inválido'
    },
    formatarTelefone(tel) {
      if (!tel || tel === '-') return '';
      var digits = String(tel).replace(/\D/g, '');
      if (digits.length === 11) {
        return '(' + digits.substring(0, 2) + ') ' + digits.substring(2, 7) + '-' + digits.substring(7);
      }
      if (digits.length === 10) {
        return '(' + digits.substring(0, 2) + ') ' + digits.substring(2, 6) + '-' + digits.substring(6);
      }
      return tel;
    },
    contatosValidos(tr) {
      if (!tr.contatosDisponiveis || tr.contatosDisponiveis.length === 0) return [];
      return tr.contatosDisponiveis.filter(function(c) {
        if (!c.contato) return false;
        var digits = String(c.contato).replace(/\D/g, '');
        return digits.length >= 10;
      });
    },
    selecionarContatoRow(tr) {
      if (!tr.contatoId) {
        tr.contatoConfirmacao = '-';
        tr.nomeContatoConfirmacao = '';
        tr.status = 'invalido';
        tr.motivoInvalido = 'Sem contato de confirmação';
        this.osSelecionadas = this.osSelecionadas.filter(id => id !== tr.osId);
        return;
      }

      const selected = tr.contatosDisponiveis.find(c => c.id === tr.contatoId);
      if (selected) {
        tr.contatoConfirmacao = selected.contato;
        tr.nomeContatoConfirmacao = selected.nome;
        
        // Re-valida o status da linha
        if (tr.horaProposta && tr.horaProposta !== '-') {
          tr.status = 'valido';
          tr.motivoInvalido = '';
          if (!this.osSelecionadas.includes(tr.osId)) {
            this.osSelecionadas.push(tr.osId);
          }
        } else {
          tr.status = 'invalido';
          tr.motivoInvalido = 'Novo horário inválido ou vazio';
          this.osSelecionadas = this.osSelecionadas.filter(id => id !== tr.osId);
        }
      }
    },
    abrirModalContatosParaLinha(tr) {
      let clienteId = tr.clienteId;
      let contratoId = tr.contratoId;

      if (!clienteId || !contratoId) {
        const foundOs = this.osList.find(o => Number(o.id) === Number(tr.osId));
        if (foundOs) {
          clienteId = foundOs.id_cliente;
          contratoId = foundOs.id_contrato;
        }
      }

      this.itemContactar = {
        id: tr.osId,
        nomeCliente: tr.cliente,
        id_cliente: clienteId,
        id_contrato: contratoId,
        id_contato_confirmacao: tr.contatoId
      };
      this.$nextTick(() => {
        if (this.$refs.modalContactarRef) {
          this.$refs.modalContactarRef.getContatos();
          this.$refs.modalContactarRef.osModal = true;
        }
      });
    },
    onContatoAtualizadoRow(payload) {
      this.preview.forEach(async tr => {
        // Fallback contract ID check if tr.contratoId is missing
        let cId = tr.contratoId;
        if (!cId) {
          const foundOs = this.osList.find(o => Number(o.id) === Number(tr.osId));
          if (foundOs) cId = foundOs.id_contrato;
        }

        if (cId === payload.idContrato) {
          tr.contatoId = payload.idContatoConfirmacao;
          tr.contatoConfirmacao = payload.contatoConfirmacao;
          tr.nomeContatoConfirmacao = payload.nomeContatoConfirmacao;
          
          let clId = tr.clienteId;
          if (!clId) {
            const foundOs = this.osList.find(o => Number(o.id) === Number(tr.osId));
            if (foundOs) clId = foundOs.id_cliente;
          }

          // Recarrega contatos locais do cliente a partir da API
          try {
            const res = await this.$http.get("contatoCliente/" + clId);
            if (res && res.data) {
              const contatos = (res.data || [])
                .filter(c => Number(c.lixeira || 0) === 0 && Number(c.tipo) === 2)
                .map(c => ({
                  id: c.id,
                  nome: c.nome || 'Contato',
                  contato: c.contato
                }));
              
              // Adiciona telefones principais do cliente
              const clienteInfoRes = await this.$http.get("cliente/" + clId);
              const cliente = (clienteInfoRes.data && clienteInfoRes.data.data) || clienteInfoRes.data;
              const finalContatos = [];
              if (cliente) {
                if (cliente.telefone) {
                  finalContatos.push({
                    id: 'cliente_telefone',
                    nome: `${cliente.nome_contato || 'Principal'} (Tel Principal)`,
                    contato: cliente.telefone
                  });
                }
                if (cliente.telefone_link) {
                  finalContatos.push({
                    id: 'cliente_telefone_link',
                    nome: `${cliente.nome_contato || 'Confirmação'} (Tel Confirmação)`,
                    contato: cliente.telefone_link
                  });
                }
              }
              contatos.forEach(c => {
                const normNum = String(c.contato).replace(/\D/g, '');
                const exists = finalContatos.some(exist => String(exist.contato).replace(/\D/g, '') === normNum);
                if (!exists) {
                  finalContatos.push(c);
                }
              });

              tr.contatosDisponiveis = finalContatos;
            }
          } catch (err) {
            console.error("Erro ao recarregar contatos do cliente:", err);
          }

          // Revalida
          if (tr.horaProposta && tr.horaProposta !== '-') {
            tr.status = 'valido';
            tr.motivoInvalido = '';
            if (!this.osSelecionadas.includes(tr.osId)) {
              this.osSelecionadas.push(tr.osId);
            }
          }
        }
      });
    },
    async baixarTemplate(tipo = 'todas') {
      try {
        this.isDownloading = true;
        this.tipoDownloading = tipo;
        this.downloadProgress = 0;
        this.downloadedSizeText = "0.0 MB";
        
        // 1. Obter a quantidade total de OSs para calcular a porcentagem real de progresso
        let totalRows = 0;
        if (tipo === 'tela') {
          totalRows = this.osList && this.osList.length > 0 ? this.osList.length : 0;
        } else {
          try {
            const countRes = await this.$http.get("os/reagendar-massa/total-ativas");
            totalRows = countRes.total || (countRes.data ? countRes.data.total : 0) || 0;
          } catch (countErr) {
            console.error("Erro ao buscar total de OSs ativas:", countErr);
            totalRows = 45000; // Fallback aproximado se a rota falhar
          }
        }
        
        // Estimamos o tamanho do arquivo compactado (ZIP do Excel) em ~54 bytes por linha de OS
        const estimatedTotalBytes = Math.max(10000, totalRows * 54);
        const self = this;
        
        const config = {
          responseType: 'arraybuffer',
          onDownloadProgress(progressEvent) {
            const loaded = progressEvent.loaded || 0;
            self.downloadedSizeText = (loaded / (1024 * 1024)).toFixed(1) + " MB";
            
            // Cálculo do progresso real em cima dos bytes de stream recebidos
            let percent = 0;
            if (progressEvent.total || progressEvent.lengthComputable) {
              const total = progressEvent.total || progressEvent.lengthComputable;
              percent = Math.round((loaded * 100) / total);
            } else {
              // Se o total não for retornado (comum em streaming chunked), usamos a estimativa baseada no total de OSs
              percent = Math.round((loaded * 100) / estimatedTotalBytes);
            }
            self.downloadProgress = Math.min(99, percent); // Trava em 99% até o término real
          }
        };
        
        let res;
        if (tipo === 'tela') {
          const idsOs = this.osList && this.osList.length > 0 ? this.osList.map(os => os.id) : [];
          res = await this.$http.post("os/reagendar-massa/template", { idsOs }, config);
        } else {
          res = await this.$http.get("os/reagendar-massa/template", config);
        }
        
        // Crava em 100% no término da requisição
        this.downloadProgress = 100;
        
        // The Connection interceptor returns response.data, so 'res' IS the arraybuffer/blob
        const rawData = res;
        
        // Check if response is actually a JSON error (server returned error as JSON)
        if (rawData && rawData.byteLength && rawData.byteLength < 500) {
          try {
            const text = new TextDecoder().decode(rawData);
            const parsed = JSON.parse(text);
            if (parsed.message) {
              throw new Error(parsed.message);
            }
          } catch (parseErr) {
            // Not JSON, proceed as binary file — this is expected
            if (parseErr.message && !parseErr.message.includes('Unexpected')) {
              throw parseErr;
            }
          }
        }
        
        const blob = new Blob([rawData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `template-reagendamento-massa.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
      } catch (err) {
        console.error("[baixarTemplate] Erro:", err);
        const msg = (err.response && err.response.data && err.response.data.message) 
          ? err.response.data.message 
          : (err.message || "Não foi possível baixar o modelo.");
        this.$vs.notify({ title: "Erro", text: msg, color: "danger" });
      } finally {
        this.isDownloading = false;
        this.tipoDownloading = "";
        this.downloadProgress = 0;
        this.downloadedSizeText = "";
      }
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    onFileChange(e) {
      const files = e.target.files;
      if (files.length > 0) {
        this.uploadExcel(files[0]);
      }
    },
    onFileDrop(e) {
      this.dragOver = false;
      const files = e.dataTransfer.files;
      if (files.length > 0) {
        this.uploadExcel(files[0]);
      }
    },
    async uploadExcel(file) {
      this.selectedFile = file;
      this.loadingTable = true;
      await this.$vs.loading({
        container: "#disparo-massa-container",
        scale: 0.6,
      });
      try {
        const formData = new FormData();
        formData.append("file", file);

        const res = await this.$http.post(
          "os/reagendar-massa/upload",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );

        const data = res.data || res;
        const rawPreview = data.preview || [];
        
        const mappedPreview = rawPreview.map(item => {
          let selectedId = item.contatoId || null;
          let nomeContato = item.nomeContatoConfirmacao || '';
          if (!selectedId && item.contatosDisponiveis && item.contatosDisponiveis.length > 0) {
            const matching = item.contatosDisponiveis.find(c => String(c.contato).replace(/\D/g, '') === String(item.contatoConfirmacao).replace(/\D/g, ''));
            if (matching) {
              selectedId = matching.id;
              if (!nomeContato) nomeContato = matching.nome || '';
            }
          }
          // Ensure nomeContatoConfirmacao reflects the selected contact in the available list
          if (selectedId && item.contatosDisponiveis && item.contatosDisponiveis.length > 0 && !nomeContato) {
            const found = item.contatosDisponiveis.find(c => c.id === selectedId);
            if (found) nomeContato = found.nome || '';
          }
          return {
            ...item,
            contatoId: selectedId,
            nomeContatoConfirmacao: nomeContato
          };
        });

        // Sort: valid contacts first (where contatoConfirmacao is not empty, null or '-')
        this.preview = mappedPreview.sort((a, b) => {
          const aHas = a.contatoConfirmacao && a.contatoConfirmacao !== '-';
          const bHas = b.contatoConfirmacao && b.contatoConfirmacao !== '-';
          if (aHas && !bHas) return -1;
          if (!aHas && bHas) return 1;
          return 0;
        });

        this.dataProposta = data.dataProposta;
        this.dataPropostaRaw = data.dataPropostaRaw;
        this.dataSelecionadaInput = data.dataPropostaRaw;

        // Auto-select valid rows
        this.osSelecionadas = this.preview
          .filter((p) => p.status === "valido")
          .map((p) => p.osId);

        this.etapa = "preview";
      } catch (err) {
        console.error(err);
        let msg = "Erro ao processar o arquivo Excel.";
        let detail = "";
        
        if (err.response && err.response.data) {
          if (typeof err.response.data === "object") {
            if (err.response.data.message) {
              msg = err.response.data.message;
            }
            if (err.response.data.error) {
              detail = ` (${err.response.data.error})`;
            }
          } else if (typeof err.response.data === "string") {
            msg = err.response.data;
          }
        } else if (err.message) {
          detail = ` (${err.message})`;
        }
        
        this.$vs.notify({
          title: "Erro",
          text: msg + detail,
          color: "danger",
          time: 7000
        });
      } finally {
        this.loadingTable = false;
        await this.$vs.loading.close(
          "#disparo-massa-container > .con-vs-loading",
        );
      }
    },
    voltarParaSelecao() {
      this.etapa = "selecao";
      this.selectedFile = null;
      this.preview = [];
      this.osSelecionadas = [];
      this.dataProposta = "";
      this.dataPropostaRaw = "";
    },
    closeModal() {
      this.closeEventSource();
      this.localActive = false;
    },
    fecharComSucesso() {
      this.$emit("success");
      this.closeEventSource();
      this.localActive = false;
    },
    toggleAll(val) {
      if (val) {
        this.osSelecionadas = this.preview
          .filter((p) => p.status === "valido")
          .map((p) => p.osId);
      } else {
        this.osSelecionadas = [];
      }
    },
    async getWatiTemplates() {
      this.loadingTemplates = true;
      try {
        // Fetch approved templates containing 'confirmacao', 'reagendar' or 'remarcado' in their name
        const res = await this.$http.get(
          "getWatiTemplates?filtro[status][]=approved&filtro[nomes][]=confirmacao&filtro[nomes][]=reagendar&filtro[nomes][]=remarcado&filtro[nomes][]=reagendamento",
        );
        if (res && res.data) {
          this.watiTemplates = res.data.data || res.data;
          if (this.watiTemplates.length === 0) {
            // Fallback: if no templates match, fetch all
            const fallbackRes = await this.$http.get(
              "getWatiTemplates?filtro[status][]=approved",
            );
            this.watiTemplates = fallbackRes.data.data || fallbackRes.data || [];
          }
        }
      } catch (err) {
        console.error(
          "[ModalReagendamentoMassa] Erro ao buscar templates:",
          err,
        );
        let errorMsg = "Erro ao buscar templates do WATI";
        if (err.response && err.response.data && err.response.data.message) {
          errorMsg = err.response.data.message;
        }
        this.$vs.notify({ title: "Erro", text: errorMsg, color: "danger" });
      } finally {
        this.loadingTemplates = false;
      }
    },
    confirmarEnvio() {
      if (this.osSelecionadas.length === 0) return;
      this.$vs.dialog({
        type: "confirm",
        color: "#00bba2",
        title: `Confirmar Reagendamento em Massa`,
        text: `Tem certeza que deseja enviar o reagendamento preventivo para as ${this.osSelecionadas.length} OSs selecionadas usando o template "${this.templateSelecionadoNome}"?`,
        acceptText: "Sim, iniciar envio",
        cancelText: "Cancelar",
        accept: this.executarEnvio,
      });
    },
    async executarEnvio() {
      this.etapa = "progresso";
      this.progress = {
        total: this.osSelecionadas.length,
        sent: 0,
        failed: 0,
        message: "Iniciando lote de reagendamento...",
        percent: 0,
        status: "processing",
      };

      try {
        const template = this.watiTemplates.find(
          (t) => t.id === this.templateSelecionadoId,
        );

        // Build the reagendamentos object mapping osId -> { data_remarcacao, hora_marcada, id_contato_confirmacao, contato }
        const reagendamentos = {};
        const selectedStrIds = this.osSelecionadas.map(id => String(id));
        this.preview.forEach((item) => {
          const itemOsIdStr = String(item.osId);
          if (selectedStrIds.includes(itemOsIdStr)) {
            reagendamentos[itemOsIdStr] = {
              data_remarcacao: item.dataPropostaRaw, // YYYY-MM-DD
              hora_marcada: item.horaProposta,
              id_contato_confirmacao: item.contatoId,
              contato: item.contatoConfirmacao,
            };
          }
        });

        const payload = {
          idsOs: selectedStrIds,
          templateName: template ? template.elementName : "reagendamento",
          templateId: this.templateSelecionadoId,
          reagendamentos,
        };

        const res = await this.$http.post("os/reagendar-massa/enviar", payload);
        const responseData = res.data || res;
        const jobId = responseData.jobId;

        this.iniciarProgressoSSE(jobId);
      } catch (err) {
        console.error(err);
        this.progress.status = "error";
        this.progress.message = "Falha ao iniciar o reagendamento em lote.";
        let errMsg = "Erro ao enviar.";
        if (err.response && err.response.data && err.response.data.message)
          errMsg = err.response.data.message;
        this.$vs.notify({ title: "Erro", text: errMsg, color: "danger" });
      }
    },
    iniciarProgressoSSE(jobId) {
      const baseUrl = this.$http.defaults.baseURL || "";
      const url = `${baseUrl.replace(
        /\/$/,
        "",
      )}/whatsapp/enviar-massa/progress/${jobId}`;

      this.eventSource = new EventSource(url);

      this.eventSource.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);

          if (
            data.status === "error" &&
            data.message === "Job não encontrado"
          ) {
            this.closeEventSource();
            return;
          }
          const oldStatus = this.progress.status;
          this.progress.status = data.status;
          this.progress.total = data.total || this.progress.total;
          this.progress.sent = data.sent || 0;
          this.progress.failed = data.failed || 0;
          this.progress.message = data.message;

          const processados = this.progress.sent + this.progress.failed;
          this.progress.percent =
            this.progress.total > 0
              ? Math.round((processados / this.progress.total) * 100)
              : 0;

          if (data.status === "completed") {
            this.progress.percent = 100;
            this.closeEventSource();
            if (oldStatus !== "completed") {
              this.$vs.notify({
                title: "Sucesso!",
                text: "Reagendamento preventivo em massa concluído!",
                color: "success",
              });
            }
          } else if (data.status === "error") {
            this.closeEventSource();
            if (oldStatus !== "error") {
              this.$vs.notify({
                title: "Erro",
                text: data.message || "Erro no processamento.",
                color: "danger",
              });
            }
          }
        } catch (e) {
          console.error("Falha no parse dos dados SSE:", e);
        }
      };

      this.eventSource.onerror = (e) => {
        console.error("Erro no SSE:", e);
        this.closeEventSource();
        if (this.progress.status === "processing") {
          this.progress.status = "completed";
          this.$vs.notify({
            title: "Aviso",
            text: "Envio em progresso no servidor.",
            color: "warning",
          });
        }
      };
    },
    closeEventSource() {
      if (this.eventSource) {
        this.eventSource.close();
        this.eventSource = null;
      }
    },
  },
};
</script>

<style scoped>
.dropzone-area {
  border: 2px dashed rgba(0, 187, 162, 0.4);
  background: rgba(0, 187, 162, 0.01);
  transition: all 0.2s ease-in-out;
}
.dropzone-area:hover,
.dropzone-active {
  border-color: #00bba2;
  background: rgba(0, 187, 162, 0.05);
}
.preview-table-container {
  max-height: 60vh;
  overflow-y: auto;
  border: 1px solid #edf2f7;
  border-radius: 6px;
  position: relative;
  padding-bottom: 56px; /* Space for fixed pagination controls */
}

/* Template download container */
.template-download-container {
  display: inline-block;
  margin-top: 15px;
  padding: 8px 20px;
  background: rgba(0, 187, 162, 0.05);
  border: 1px solid rgba(0, 187, 162, 0.2);
  border-radius: 8px;
}
.template-download-link {
  color: #00bba2;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.15s ease;
}
.template-download-link:hover {
  color: #009d89;
  text-decoration: underline;
}


/* ═══ Styling preview table elements for premium feel ═══ */
::v-deep .modal-reagendamento-massa .vs-table--thead th {
  background: #f7fafc;
  color: #2d3748;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 11px;
  letter-spacing: 0.5px;
  padding: 12px 10px;
}

::v-deep .modal-reagendamento-massa .vs-table--tr {
  transition: background 0.15s ease;
}

::v-deep .modal-reagendamento-massa .vs-table--tr:hover {
  background: rgba(0, 187, 162, 0.03) !important;
}

/* Premium editable inputs inside table */
.table-cell-input {
  border: 1px solid #e2e8f0;
  border-radius: 6px !important;
  padding: 5px 8px;
  font-size: 12px;
  color: #2d3748;
  outline: none;
  background-color: #fff;
  transition: all 0.15s ease-in-out;
}
.table-cell-input:focus {
  border-color: #00bba2;
  box-shadow: 0 0 0 3px rgba(0, 187, 162, 0.12);
}
.table-cell-input::placeholder {
  color: #cbd5e0;
  font-weight: 400;
}

/* ═══ OS ID Badge ═══ */
.os-id-badge {
  display: inline-block;
  font-weight: 800;
  font-size: 12px;
  color: #2d3748;
  background: #edf2f7;
  padding: 2px 8px;
  border-radius: 4px;
  letter-spacing: 0.3px;
  font-feature-settings: "tnum";
}

/* ═══ Status Badges ═══ */
.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.2px;
  white-space: nowrap;
  cursor: default;
  transition: all 0.15s ease;
}
.status-badge--success {
  background: rgba(40, 199, 111, 0.1);
  color: #1e8449;
  border: 1px solid rgba(40, 199, 111, 0.2);
}
.status-badge--danger {
  background: rgba(234, 84, 85, 0.08);
  color: #c0392b;
  border: 1px solid rgba(234, 84, 85, 0.18);
  cursor: help;
}

/* ═══ Table Date & Time cells ═══ */
.table-date-text {
  font-size: 11px;
  font-weight: 500;
  color: #4a5568;
  letter-spacing: 0.2px;
}
.table-time-pill {
  display: inline-block;
  background: #edf2f7;
  color: #2d3748;
  font-weight: 700;
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 4px;
  font-feature-settings: "tnum";
}
.table-time-empty {
  color: #cbd5e0;
  font-size: 13px;
}

/* ═══ Invalid row subtle highlight ═══ */
::v-deep .modal-reagendamento-massa .tr-invalido {
  background: rgba(234, 84, 85, 0.02) !important;
}
::v-deep .modal-reagendamento-massa .tr-invalido:hover {
  background: rgba(234, 84, 85, 0.04) !important;
}

/* Date picker input styling */
.date-picker-input {
  border: 1px solid rgba(0, 187, 162, 0.3);
  border-radius: 6px;
  padding: 5px 12px;
  font-size: 13px;
  font-weight: 600;
  color: #00bba2;
  outline: none;
  background-color: #fff;
  cursor: pointer;
  transition: all 0.15s ease;
}
.date-picker-input:focus {
  border-color: #00bba2;
  box-shadow: 0 0 0 3px rgba(0, 187, 162, 0.1);
}

/* Fix pagination to the bottom of the scroll container */
::v-deep .modal-reagendamento-massa .vs-table--pagination {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  border-top: 1px solid #edf2f7;
  padding: 8px 15px;
  z-index: 10;
  margin: 0;
  display: flex;
  justify-content: center;
}

/* ═══ Skeleton Loading ═══ */
.skeleton-cell {
  background: #e2e8f0;
  cursor: wait;
}
.animate-shimmer {
  background: linear-gradient(90deg, #edf2f7 25%, #e2e8f0 50%, #edf2f7 75%);
  background-size: 200% 100%;
  animation: shimmer-animation 1.5s infinite;
}
@keyframes shimmer-animation {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* ═══ Progress Bar ═══ */
.progress-container {
  padding: 0 8px;
}
.progress-info {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}
.progress-bar-bg {
  width: 100%;
  height: 12px;
  background: #e2e8f0;
  border-radius: 999px;
  overflow: hidden;
}
.progress-bar-fill {
  height: 100%;
  border-radius: 999px;
  transition: width 0.6s ease;
}

/* ═══ Counters ═══ */
.counters-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}
.counter-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 16px 8px;
  border-radius: 12px;
  background: #f8f9fb;
  border: 1px solid #edf2f7;
}
.counter-value {
  font-size: 1.6rem;
  font-weight: 800;
  line-height: 1;
}
.counter-label {
  font-size: 0.75rem;
  color: #a0aec0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* ═══ Spinner ═══ */
.spinner-pulse {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #00bba2;
  margin: 0 auto;
  animation: pulse-ring 1.2s ease-in-out infinite;
}
@keyframes pulse-ring {
  0% { transform: scale(0.8); opacity: 1; }
  50% { transform: scale(1.1); opacity: 0.5; }
  100% { transform: scale(0.8); opacity: 1; }
}
.animate-bounce-in {
  animation: bounceIn 0.5s ease;
}
@keyframes bounceIn {
  0% { transform: scale(0); }
  50% { transform: scale(1.2); }
  100% { transform: scale(1); }
}

/* ═══ Dot Pulse ═══ */
.dot-pulse-inline {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #a0aec0;
  margin-right: 4px;
  animation: dot-blink 1s infinite;
}
@keyframes dot-blink {
  0%, 100% { opacity: 0.3; }
  50% { opacity: 1; }
}

.spinner-inline {
  width: 14px;
  height: 14px;
  border: 2px solid rgba(0, 0, 0, 0.1);
  border-top-color: #7367f0;
  border-radius: 50%;
  animation: spin-inline 0.8s linear infinite;
  display: inline-block;
  vertical-align: middle;
}
@keyframes spin-inline {
  to { transform: rotate(360deg); }
}

/* ═══ History Tab Table Loading ═══ */
.table-loading {
  opacity: 0.6;
  pointer-events: none;
}
</style>

<style>
/* ═══ Wider Modal styling (Global to override Vuesax body portal) ═══ */
.modal-reagendamento-massa .vs-popup {
  width: 750px !important;
  max-width: 95vw !important;
  transition: width 0.3s ease, max-width 0.3s ease;
}

.modal-reagendamento-massa.modal-expanded .vs-popup {
  width: 1450px !important;
}

.modal-reagendamento-massa.modal-historico-largo .vs-popup {
  width: 1100px !important;
}

/* Ensure Vuesax confirm dialogs are on top of popups */
.con-vs-dialog {
  z-index: 70000 !important;
}

/* Dropdown do el-select dentro do modal — z-index acima do overlay do vs-popup */
.select-contato-popper {
  z-index: 80000 !important;
}
</style>


